import React from 'react';

const DropZone = ({ active, children }) => {
    return (
        <div className="relative">
            {children}
            {active && (
                <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-2xl border-2 border-dashed border-emerald-500/70 bg-emerald-500/10 text-sm font-medium">
                    Отпустите файлы для загрузки
                </div>
            )}
        </div>
    );
};

export default DropZone;
